import * as React from 'react';
import classes from './ListSectionTitle.module.scss';
import { WithChildren } from '../../../../models/children-props';

export type ListSectionTitleViewProps = WithChildren & {
  //
  type: 'li' | 'div';
};

export const ListSectionTitleView = (props: ListSectionTitleViewProps): JSX.Element => {
  const ItemTag = `${props.type}` as keyof Pick<JSX.IntrinsicElements, 'li' | 'div'>;
  return (
    <ItemTag className={classes.ListSectionTitle}>
      <h6>{props.children}</h6>
    </ItemTag>
  );
};
